import { setProfileComplete } from "../redux/authSlice";
import { setUser, setProfile, setLoading } from "../redux/mentorSlice";
import { api1 } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "./apiEndpoints";

export const editProfile = (payload) => async (dispatch) => {
  try {
    const formData = new FormData();
    // Append text fields
    formData.append("email", payload.email);
    formData.append("firstName", payload.firstName);
    formData.append("lastName", payload.lastName);
    formData.append("gender", payload.gender);
    formData.append("country", payload.country);
    formData.append("state", payload.state);
    formData.append("city", payload.city);
    formData.append("ageGroup", String(payload.ageGroup));
    formData.append("race", payload.race);
    formData.append("bio", payload.bio);
    formData.append("higherEducationLevel", payload.higherEducationLevel);
    formData.append("employmentStatus", payload.employmentStatus);
    formData.append("professionalExperience", payload.professionalExperience);
    formData.append("yearOfExperience", payload.yearOfExperience);
    formData.append("currentJobOccupation", payload.currentJobOccupation);
    formData.append(
      "formalMentoringOrCoachingExperience",
      payload.formalMentoringOrCoachingExperience
    );
    formData.append("yearsOfMentoring", payload.yearsOfMentoring);
    formData.append("whyDoYouWantToBeMentor", payload.whyDoYouWantToBeMentor);
    formData.append("mentorExperiance", payload.mentorExperiance);
    formData.append("industry", payload.industry);
    formData.append("general", payload.general);
    formData.append("AILiteracySkills", payload.AILiteracySkills);
    formData.append("appliedAISkills", payload.appliedAISkills);
    formData.append("ethicsResponsibleAI", payload.ethicsResponsibleAI);
    formData.append("softAISkills", payload.softAISkills);
    formData.append("strategicAISkills", payload.strategicAISkills);
    formData.append("technicalAISkills", payload.technicalAISkills);
    formData.append(
      "TechnicalDevelopmentRoles",
      payload.TechnicalDevelopmentRoles
    );
    formData.append("InfrastureRoles", payload.InfrastureRoles);
    formData.append("ethicsRoles", payload.ethicsRoles);
    formData.append("buisnessRole", payload.buisnessRole);
    formData.append("CreativeRole", payload.CreativeRole);
    formData.append("Compliance", payload.Compliance);
    formData.append("EmergingAI", payload.EmergingAI);
    formData.append(
      "MachineLearningDeepLearningPlatforms",
      payload.MachineLearningDeepLearningPlatforms
    );
    formData.append(
      "AutoMLNoCodeLowCodeAIPlatforms",
      payload.AutoMLNoCodeLowCodeAIPlatforms
    );
    formData.append(
      "NaturalLanguageProcessingTools",
      payload.NaturalLanguageProcessingTools
    );
    formData.append("ComputerVisionTools", payload.ComputerVisionTools);
    formData.append("GenerativeAITools", payload.GenerativeAITools);
    formData.append("MLOpsDeploymentTools", payload.MLOpsDeploymentTools);
    formData.append(
      "DataScienceVisualizationTools",
      payload.DataScienceVisualizationTools
    );
    formData.append("CommunicationSkills", payload.CommunicationSkills);
    formData.append(
      "InterpersonalTeamworkSkills",
      payload.InterpersonalTeamworkSkills
    );
    formData.append(
      "CriticalThinkingProblemSolving",
      payload.CriticalThinkingProblemSolving
    );
    formData.append("SelfManagementSkills", payload.SelfManagementSkills);
    formData.append("LeadershipInfluence", payload.LeadershipInfluence);
    formData.append("technology", payload.technology);
    formData.append("ai_application", payload.ai_application);
    formData.append("openToFacilitating", payload.openToFacilitating);
    formData.append("openToConsulting", payload.openToConsulting);
    formData.append("openToGroup", payload.openToGroup);
    formData.append("minSession", payload.minSession);
    formData.append("pricePerMentee", payload.pricePerMentee);
    formData.append("openToVolunteer", payload.openToVolunteer);
    formData.append("volunteerMins", payload.volunteerMins);
    formData.append("maximumNumbers", payload.maximumNumbers);
    formData.append("linkedIn", payload.linkedIn);
    formData.append("twitter", payload.twitter);
    formData.append("personalWebsite", payload.personalWebsite);
    formData.append(
      "certificationName",
      payload.certificationName ? payload.certificationName : ""
    );
    formData.append(
      "certificationProvider",
      payload.certificationProvider ? payload.certificationProvider : ""
    );
    formData.append(
      "certificationDescription",
      payload.certificationDescription ? payload.certificationDescription : ""
    );
    formData.append(
      "certificationIssueDate",
      payload.certificationIssueDate ? payload.certificationIssueDate : ""
    );
    formData.append(
      "certificationExpiryDate",
      payload.certificationExpiryDate ? payload.certificationExpiryDate : ""
    );
    formData.append(
      "certificationId",
      payload.certificationId ? payload.certificationId : ""
    );
    formData.append(
      "certificationUrl",
      payload.certificationUrl ? payload.certificationUrl : ""
    );
    // Append files (Only if they exist)
    if (payload.profileImage) {
      formData.append("profileImage", payload.profileImage);
    }
    if (payload.cv) {
      formData.append("cv", payload.cv);
    }

    const response = await api1.put("/api/mentorProfile/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    dispatch(setProfile(response.data.data));
    dispatch(setProfileComplete(true));

    return response.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    // Throw error so it can be caught in the component
    throw error;
  }
};

export const getProfile = (payload) => async (dispatch) => {
  try {
    dispatch(setLoading()); 
    const response = await api1.get(
      `/api/mentorProfile/${payload.userId ? payload.userId : "null"}`
    );
    if (!payload.userId) {
      dispatch(setUser({ isVerified: response.data.data.isVerified }));
    }
    dispatch(setProfile(response.data.data));

    return response.data.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    dispatch(setProfile(null));
  }
};

export const getAllMentorsApi = async () => {
  try {
    const response = await api1.get(API_ENDPOINTS.GET_MENTORS_LIST);
    return response.data.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return null;
  }
};
